<template>
	<NuxtLink to="/" active-class="no-class">
		<img class="h-7 w-auto cursor-pointer" src="/images/jmi-logo-white.svg" alt="Just Move In">
	</NuxtLink>
</template>
